class CollapasbleInvoicesConroller {
  constructor ($sce, $timeout, ProductService, VehicleService, UserService, I18n, $log, Localization, $rootScope, $scope) {
    'ngInject'
    this.$sce = $sce
    this.$timeout = $timeout
    this.$log = $log
    this.productService = ProductService
    this.vehicleService = VehicleService
    this.userService = UserService
    this.I18n = I18n
    this.Localization = Localization
    this.$rootScope = $rootScope
    this.$scope = $scope
    this.fold = true
    this.loaded = this.init()
  }

  init () {
    return this.vehicleService.getCurrentSelectedVehicle()
    .then((vehicle) => {
      if (!vehicle) {
        this.$log.error('Unable to get current selected vehicle.')
        return Promise.reject('Unable to get current selected vehicle.')
      }
      this.vehicle = vehicle
      this.safeApply()
    })
  }

  getDate (str) {
    return str ? new Date(str) : null
  }

  downloadInvoice (order) {
    // TODO change this if invoice dl not working
    this.isProcessing = true
    this.userService.refresh()
    .then(() => {
      this.urlDowloadInvoice = this.$sce.trustAsResourceUrl(this.productService.getEndpoint() + '/orders/' + order.orderRef + '/invoice')
      this.tokenParam = this.userService.getCurrentToken().access_token
      this.local = this.I18n.getLanguage()
      this.country = this.Localization.getCountry()
      this.orderRef = order.orderRef
      this.$timeout(() => {
        this.$rootScope.$broadcast('SubmitInvoiceForm', {formName: order.orderRef})
      }, 1000)
      this.isProcessing = false
      return Promise.resolve()
    }, (err) => {
      this.isProcessing = false
      this.$log.debug('refresh failed')
      return this.userService.resetBufferAndLogout(err)
    })
  }

  safeApply () {
    const phase = this.$rootScope.$$phase
    if (phase !== '$apply' && phase !== '$digest') {
      this.$scope.$apply()
    }
  }

}

export default CollapasbleInvoicesConroller



// WEBPACK FOOTER //
// ./src/app/pages/vehicle/manage-my-rlink/components/collapsable-invoices/collapsable-invoices.controller.js